export default __webpack_public_path__ + "static/media/chart-box.27653902.svg";